import React, { type FC } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { getNav4Rollout } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-nav4-rollout/index.tsx';
import { useAnalyticsEvents, fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useEffectWithoutConcurrency } from '@atlassian/jira-react-strict-mode/src/useEffectWithoutConcurrency.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import {
	V3,
	V4,
} from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/nav-state.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const Nav4RolloutAnalytics: typeof Nav4RolloutAnalyticsWithoutErrorBoundary = (props) => (
	<JSErrorBoundary
		id="nav4-rollout-analytics"
		fallback="unmount"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
	>
		<Nav4RolloutAnalyticsWithoutErrorBoundary {...props} />
	</JSErrorBoundary>
);

export const Nav4RolloutAnalyticsWithoutErrorBoundary: FC = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	// This should only run once. Fix for https://jplat.atlassian.net/browse/BLU-5516
	// and for React Concurrent.
	useEffectWithoutConcurrency(() => {
		const nav4Rollout = getNav4Rollout();

		// Fifty-character limit on gate keys.
		if (fg('blu-7495-add-nav-version-to-rollout-analytics-even')) {
			// Now that the GA stage has started, nearly all tenants should be in a rollout stage.
			// Don't exclude tenants with a stage of 'none' as we may need to know who they are.
			fireTrackAnalytics(createAnalyticsEvent({}), 'topNav viewed', {
				...nav4Rollout,
				navState: getWillShowNav4() ? V4 : V3,
			});
		} else if (nav4Rollout.stage !== 'none') {
			fireTrackAnalytics(createAnalyticsEvent({}), 'topNav viewed', nav4Rollout);
		}
	}, [createAnalyticsEvent]);

	return null;
};
